<template>
    <v-flex xs12>
        <app-select-saved-polygon v-for="i in numPolygons" ref="selectPolygon" :key="i" @selected="onSelectPolygon"></app-select-saved-polygon>
        <v-btn block :disabled="numPolygons >= 5" @click="numPolygons += 1">{{$t(`comparative.add`)}}</v-btn>
        <v-btn block :disabled="numPolygons <= 2" @click="numPolygons -= 1">{{$t(`comparative.delete`)}}</v-btn>
    </v-flex>
</template>

<script>
import AppSelectSavedPolygon from '@/components/core/utils/shared-components/select-saved-polygon'
import GeomPolygon from 'ol/geom/polygon'
import Feature from 'ol/feature'

/**
 * Componente para añadir polígonos de búsqueda para comparar
 */
export default {
    data() {
        return {
            numPolygons: 2,
            polygons: []
        }
    },
    components: {
        AppSelectSavedPolygon
    },

    methods: {
        onSelectPolygon(){
            const polygons = this.$refs.selectPolygon.map(ref => {
                if(!ref.selectedPolygon) return
                const {selectedPolygon: { name, coordinates }} = ref
                return new Feature({ geometry: new GeomPolygon(coordinates), properties: { name } })
            });

            this.polygons = polygons
            this.$emit('changed', polygons)
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AddPolygons.vue?d2c2669c